export const hotelArrangementPlanFee = {
  feeType: {
    mandatoryFee: "Mandatory Fee",
    mandatoryTax: "Mandatory Tax",
    resortFee: "Resort Fee",
  },
};
